import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { FetchMonthSummaryReport } from "../../../domain/useages/user-summary-report/fetch-month-summary-report";
import { RemoteMonthlySummaryReport } from "../../../data/usecases/user-summary-report/remote-fetch-monthly-summary-report";
import { MonthSummaryReportType } from "../../../domain/models/user-summary-report/month-summary-report";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMonthSummaryReportInterface {
  fetchMonthSummaryReport: Function;
  monthSummaryReportData: MonthSummaryReportType;
  monthSummaryState: FetchState;
}

const initialStates = {
  monthSummaryReportData: {} as MonthSummaryReportType,
  monthSummaryState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthSummaryReportSlice: StateCreator<
  FetchMonthSummaryReportInterface
> = (set, get) => ({
  ...initialStates,
  fetchMonthSummaryReport: async (
    month: number,
    year: number,
    user_id: number,
    department_id: number
  ) => {
      const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
      const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    set({ monthSummaryState: FetchState.LOADING });

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteMonthlySummaryReport: FetchMonthSummaryReport =
      new RemoteMonthlySummaryReport(
        `${BASE_URL}${Endpoints.MONTH_SUMMARY_REPORT}`,
        axiosHttpClient
      );
    let result = await remoteMonthlySummaryReport.fetch(
      month,
      year,
      user_id,
      department_id
    );

    if (result.attendances.length != 0 && result.all_visits.length != 0) {
      set({
        monthSummaryReportData: result,
        monthSummaryState: FetchState.SUCCESS,
      });
    } else if (
      result.attendances.length === 0 &&
      result.all_visits.length === 0
    ) {
      set({
        monthSummaryReportData: result,
        monthSummaryState: FetchState.ERROR,
      });
    } else {
      set({
        monthSummaryReportData: result,
        monthSummaryState: FetchState.ERROR,
      });
    }
  },
});
